module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-7"
    }
  }, [_c('h2', {
    staticClass: "chap2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("This book is dedicated to my fantastic parents, Maria Rosaria and Benedetto, for the great love and fundamental support that they continue to give me every day. Thanks to their precious observations deriving from long experience, the present work is much more complete and easy to read.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A very special mention goes to the Spanish re-enactment group and living history association Athenea Prómakhos, for providing me with the magnificent and detailed photos that illustrate this book. Without their incredible work of research and reenactment, the present work would have not been the same. In particular, I want to express my deep gratitude to Jonatan Prieto: he enjoyed and supported the idea of this book from the beginning and helped me in every phase of the production with great generosity and patience.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55ec0aa0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/006_Acknowledgements.vue
// module id = 72
// module chunks = 0